
















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'JumpstartSelectedLocation',
  components: {
    StaticMap: () => import('@/components/StaticMap.vue'),
  },
  props: {
    location: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(_, { emit }) {
    /**
     * Executes the 'onReset' event.
     */
    const onResetAction = () => {
      emit('reset');
    };

    /**
     * Executes the 'onRemove' event.
     */
    const onRemoveAction = () => {
      emit('remove');
    };

    return { onResetAction, onRemoveAction };
  },
});
